import {Directive, HostListener, input} from '@angular/core';

@Directive({
  selector: '[stopClickPropagation]',
  standalone: true
})
export class StopClickPropagationDirective {
  stopClickPropagation = input<boolean | string>();

  @HostListener('click', ['$event'])
  onClick(event: Event) {
    if (typeof this.stopClickPropagation() === 'string' || this.stopClickPropagation()) {
      event.stopPropagation();
    }
  }
}
